var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePicDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.5137,
    r: 32,
    fill: "#161C27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42773 53.0135C13.2977 45.9852 22.1266 41.5137 32 41.5137C41.8734 41.5137 50.7025 45.9853 56.5724 53.0138C50.7025 60.0422 41.8735 64.5137 32.0002 64.5137C22.1268 64.5137 13.2977 60.0421 7.42773 53.0135Z",
    fill: "#B0B7C3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 25.5137,
    r: 12,
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicDark);
export default __webpack_public_path__ + "static/media/profile-pic-dark.05dca6dd6e51b19f4175c4e5f73fb9f8.svg";
export { ForwardRef as ReactComponent };